import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import authService from '../../services/auth';

const AuthStatus: React.FC = () => {
  const [authInfo, setAuthInfo] = useState<any>({});
  const [testResult, setTestResult] = useState<string>('');

  const checkAuthStatus = () => {
    const token = localStorage.getItem('token');
    const emisToken = localStorage.getItem('emis_auth_token');
    const user = localStorage.getItem('emis_user');
    const isAuth = authService.isAuthenticated();

    setAuthInfo({
      token,
      emisToken,
      user: user ? JSON.parse(user) : null,
      isAuthenticated: isAuth,
      tokensMatch: token === emisToken,
    });
  };

  const testAPICall = async () => {
    const token = localStorage.getItem('emis_auth_token') || localStorage.getItem('token');
    if (!token) {
      setTestResult('❌ No token found!');
      return;
    }

    try {
      const response = await fetch('http://localhost:8000/api/v1/core/regions/', {
        headers: {
          'Authorization': `Token ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTestResult(`✅ API call successful! Found ${data.count} regions`);
      } else {
        setTestResult(`❌ API call failed: ${response.status} ${response.statusText}`);
      }
    } catch (error: any) {
      setTestResult(`❌ Error: ${error.message}`);
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Authentication Status
        </Typography>

        <Box sx={{ my: 3 }}>
          <Button variant="contained" onClick={checkAuthStatus} sx={{ mr: 2 }}>
            Refresh Status
          </Button>
          <Button variant="contained" color="secondary" onClick={testAPICall}>
            Test API Call
          </Button>
        </Box>

        {testResult && (
          <Alert severity={testResult.startsWith('✅') ? 'success' : 'error'} sx={{ mb: 2 }}>
            {testResult}
          </Alert>
        )}

        <Table>
          <TableBody>
            <TableRow>
              <TableCell><strong>Is Authenticated:</strong></TableCell>
              <TableCell>{authInfo.isAuthenticated ? '✅ Yes' : '❌ No'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><strong>Token (token):</strong></TableCell>
              <TableCell sx={{ wordBreak: 'break-all', fontFamily: 'monospace', fontSize: '0.75rem' }}>
                {authInfo.token || '❌ Not found'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell><strong>Token (emis_auth_token):</strong></TableCell>
              <TableCell sx={{ wordBreak: 'break-all', fontFamily: 'monospace', fontSize: '0.75rem' }}>
                {authInfo.emisToken || '❌ Not found'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell><strong>Tokens Match:</strong></TableCell>
              <TableCell>
                {authInfo.token && authInfo.emisToken
                  ? authInfo.tokensMatch
                    ? '✅ Yes'
                    : '⚠️ No - tokens differ!'
                  : 'N/A'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell><strong>User Data:</strong></TableCell>
              <TableCell>
                {authInfo.user ? (
                  <Box sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
                    <div>Username: {authInfo.user.username}</div>
                    <div>Name: {authInfo.user.full_name}</div>
                    <div>Email: {authInfo.user.email}</div>
                  </Box>
                ) : (
                  '❌ Not found'
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default AuthStatus;
